import ruErrorsJson from "./ru/errors.json";
import ruValidateJson from "./ru/validate.json";
import kaErrorsJson from "./ka/errors.json";
import kaValidateJson from "./ka/validate.json";
import enErrorsJson from "./en/errors.json";
import enValidateJson from "./en/validate.json";
import uzErrorsJson from "./uz/errors.json";
import uzValidateJson from "./uz/validate.json";

export const ruErrors = ruErrorsJson;
export const ruValidate = ruValidateJson;
export const kaErrors = kaErrorsJson;
export const kaValidate = kaValidateJson;

export const enErrors = enErrorsJson;
export const enValidate = enValidateJson;

export const uzErrors = uzErrorsJson;
export const uzValidate = uzValidateJson;

const getCookieLocale = () => {
  // Проверяем, выполняется ли код на сервере
  const isServer = typeof window === "undefined" || typeof document === "undefined";

  // Если код выполняется на сервере, возвращаем null
  if (isServer) {
    return null;
  }

  try {
    const cookies = document.cookie.split(";");
    const currentUrl = window.location.pathname;

    // Определяем текущее приложение по URL
    const isCRM = currentUrl.includes("/admin");

    // Проверяем, содержит ли URL локаль языка (характерно для main)
    const urlLocaleMatch = currentUrl.match(/^\/(ru|en|ka|uz)\//);
    const isMain = !isCRM && urlLocaleMatch;

    // Для main используем donut-locale или локаль из URL
    if (isMain) {
      // Можно использовать локаль из URL
      if (urlLocaleMatch && urlLocaleMatch[1]) {
        return urlLocaleMatch[1];
      }

      const mainCookie = cookies.find((cookie) => cookie.trim().startsWith("donut-locale="));
      if (mainCookie) {
        return mainCookie.split("=")[1];
      }
    }

    // Для CRM используем donut-locale
    if (isCRM) {
      const crmCookie = cookies.find((cookie) => cookie.trim().startsWith("donut-locale="));
      if (crmCookie) {
        return crmCookie.split("=")[1];
      }
    }

    // Для Client-view используем donut-project-locale
    if (!isCRM && !isMain) {
      const clientViewCookie = cookies.find((cookie) => cookie.trim().startsWith("donut-project-locale="));
      if (clientViewCookie) {
        return clientViewCookie.split("=")[1];
      }
    }

    // Если не нашли нужную куку, проверяем альтернативную
    const anyLocaleCookie = cookies.find(
      (cookie) => cookie.trim().startsWith("donut-locale=") || cookie.trim().startsWith("donut-project-locale="),
    );

    if (anyLocaleCookie) {
      return anyLocaleCookie.split("=")[1];
    }
  } catch (error) {
    console.error("Error in getCookieLocale:", error);
    return null;
  }

  return null;
};

export const getLocaleValidation = () => {
  const locale =
    getCookieLocale() || (typeof window !== "undefined" ? window.localStorage.getItem("app-language") : null) || "ru";

  switch (locale) {
    case "ka":
      return kaValidateJson;
    case "en":
      return enValidateJson;
    case "uz":
      return uzValidateJson;
    case "ru":
    default:
      return ruValidateJson;
  }
};

export const getErrorValidation = () => {
  const locale =
    getCookieLocale() || (typeof window !== "undefined" ? window.localStorage.getItem("locale") : null) || "ru";

  switch (locale) {
    case "ka":
      return kaErrorsJson;
    case "en":
      return enErrorsJson;
    case "uz":
      return uzErrorsJson;
    case "ru":
    default:
      return ruErrorsJson;
  }
};
